<template>
  <div class="swiper">
    <v-carousel
      height="200"
      cycle
      :interval="interval"
      v-model="current"
      reverse-transition="fade-transition"
      transition="fade-transition"
      hide-delimiters
    >
      <v-carousel-item v-for="(item, i) in items" :key="i">
        <v-sheet tile @click="fnLinkto(item)">
          <v-img :src="utils.checkFile(item.imageUrl)" aspect-ratio="1.7">
            <v-sheet class="px-3 py-2 caption" align="start" justify="end">
              {{ item.title }}
            </v-sheet>
          </v-img>
        </v-sheet>
      </v-carousel-item>
    </v-carousel>
  </div>
</template>

<script>
// 自定义设置
import config from "@/utils/config";
// 自定义功能
import utils from "@/utils";
export default {
  name: "CSwiper",
  props: {
    items: { type: Array, required: false, default: () => [] },
    interval: { type: Number, required: false, default: 3000 },
  },
  data: () => ({
    utils: utils,
    baseUrl: config.baseUrl,
    current: 0,
  }),
  created() {},
  methods: {
    fnLinkto(item) {
      this.$router.push(`/content/${item.channelId}/${item.id}`);
    },
  },
};
</script>
<style lang="scss" scoped>
.caption {
  filter: opacity(0.8);
  color: #fff;
  background: rgba(0, 0, 0, 0.6) !important;
  position: relative;
  bottom: -160px;
  white-space: nowrap;
  text-overflow: ellipsis;
}
</style>